<template>
  <section
    v-if="lyric"
    id="lyrics"
  >
    <MainTitle
      title="Ízelítő a szövegtárból"
      subtitle="Dalszövegtár"
      sublink="/mediatar/dalszovegek"
    />
    <div class="flex flex-col lg:flex-row bg-white py-[35px] px-[25px]">
      <div class="w-full lg:w-1/2">
        <p v-html="toHtml(calculateLyrics(lyric.lyric,1))" />
      </div>
      <div class="w-full lg:w-1/2">
        <p v-html="toHtml(calculateLyrics(lyric.lyric,2))" />
      </div>
    </div>
    <div class="flex flex-col lg:flex-row bg-white mt-2 py-[35px] px-[25px]">
      <div class="w-full lg:w-1/2">
        <div
          v-if="lyric.performer && lyric.performer.length"
          class="my-2"
        >
          <p class="font-semibold">
            Előadó:
          </p>
          <p>
            <span
              v-for="(performer, index) in lyric.performers"
              :key="$unique() + index"
            >
              {{ performer.name
              }}{{
                index === lyric.performers.length - 1 ? "" : ", "
              }}
            </span>
          </p>
        </div>
        <div
          v-if="lyric.settlements && lyric.settlements.length"
          class="my-2"
        >
          <p class="font-semibold">
            Település:
          </p> 
          <p>
            <span
              v-for="(settlement, index) in lyric.settlements"
              :key="$unique() + index"
            >
              {{ settlement.name
              }}{{
                index === lyric.settlements.length - 1 ? "" : ", "
              }}
            </span>
          </p>
        </div>
        <div
          v-if="lyric.counties && lyric.counties.length"
          class="my-2"
        >
          <p class="font-semibold">
            Vármegye:
          </p>
              
          <p>
            <span
              v-for="(county, index) in lyric.counties"
              :key="$unique() + index"
            >
              {{ county.name
              }}{{ index === lyric.counties.length - 1 ? "" : ", " }}
            </span>
          </p>
        </div>
        <div
          v-if="lyric.regions && lyric.regions.length"
          class="my-2"
        >
          <p class="font-semibold">
            Tájegység:
          </p>
         
          <p>
            <span
              v-for="(region, index) in lyric.regions"
              :key="$unique() + index"
            >
              {{ region.name
              }}{{ index === lyric.regions.length - 1 ? "" : ", " }}
            </span>
          </p>
        </div>
      </div>
      <div class="w-full lg:w-1/2">
        <div
          v-if="(lyric.recordings && lyric.recordings.length) || (lyric.sources && lyric.sources.length)"
          class="my-2"
        >
          <p class="font-semibold">
            Forrás:
          </p>
          
          <div
            v-if="lyric.recordings && lyric.recordings.length"
          >
            <p>
              <nuxt-link
                :to="
                  '/mediatar/felvetelek/' +
                    lyric.recordings[0].id +
                    '/' +
                    lyric.recordings[0].slug
                "
                class="text-yellow underline"
              >
                {{ lyric.source ? lyric.source : lyric.recordings[0].album.title }}
              </nuxt-link>
            </p>
          </div>
          <div
            v-if="lyric.sources && lyric.sources.length"
          >
            <nuxt-link
              :to="
                '/mediatar/dalszovegek/' + lyric.id + '/' + lyric.slug
              "
              class="text-yellow underline"
            >
              <p>
                <span
                  v-for="(item, index) in lyric.sources"
                  :key="$unique() + index"
                  :class="{ disabled: !item.url }"
                >
                  {{
                    item.source +
                      (lyric.source ? " " + lyric.source : "")
                  }}
                </span>
              </p>
            </nuxt-link>
          </div>
        </div>
        <button
          class="btn btn-yellow mt-[35px] py-[12px] px-[46px]"
          @click.prevent="showAnotherLyric()"
        >
          Mutass másikat!
        </button>
      </div>
    </div>
  </section>
</template>
<script>
const MainTitle = () => import("~/components/folkradio/MainTitle.vue")

export default {
  components: {
    MainTitle
  },
  data () {
    return {
      lyric: null
    }
  },
  fetch(){
    this.$axios
      .get("media/lyrics?sort=random&limit=1&filter[advised]=true").then(response => {
        this.lyric = response.data.data[0];
      })
  },
  methods: {
    calculateLyrics(text,columnId){
      if(text!==""){
      var textArray = text.split('\n');
      var firstColumnArray = new Array;
      var secondColumnArray = new Array;

       for (let index = 0; index < textArray.length; index++) {
         if(index< textArray.length/2){
          firstColumnArray +=  textArray[index] +'\n';
         }else{
          secondColumnArray +=  textArray[index] +'\n';
         }
        }
       return  columnId==1 ? firstColumnArray.toString() : secondColumnArray.toString()
      }else{
        return " "
      }
      
    },
    showAnotherLyric() {
      this.$axios
        .get("media/lyrics?sort=random&limit=1&filter[public]=true")
        .then(response => {
          this.lyric = response.data.data[0];
          console.log(this.lyric)
          this.$forceUpdate();
          setTimeout(() => {
            document.getElementById("lyrics").scrollIntoView({block: "start", inline: "nearest"});
          }, 100)
          
        });
    },
    toHtml(text) {
      return text
        .trim()
        .replace(/\r\n/g, "<br>")
        .replace(/\n/g, "<br>");
    }
  }
}
</script>
